<template>
  <div class="pagina-margem">
    <div v-if="!mobile">
      <div class="row align-center justify-center" id="base-desktop">
        <div class="row col-12 align-center secao-anti-quebra">
          <div
            style="width: 15%"
            class="column justify-center items-center q-pa-sm"
          >
            <q-img
              v-if="logoVendor"
              :src="logoVendor"
              crossorigin="*"
              style="max-width: 180px; max-height: 80px"
              fit="contain"
              @error="onLogoError"
            />
            <q-img
              v-else
              crossorigin="*"
              src="../../../../assets/MULTPEX_VETOR.png"
              style="max-width: 180px; max-height: 80px"
              fit="contain"
            />
          </div>

          <section class="column" style="width: 85%">
            <div class="border row q-mb-sm">
              <div
                class="border-right q-pl-sm text-bold row justify-center items-center"
                style="width: 70%"
              >
                PERMISSÃO PARA TRABALHO
              </div>
              <div class="q-pl-sm text-bold" style="width: 30%">
                Nº:
                {{ pt.ptId ? pt.ptId.toString().padStart(7, "0") : "0000000" }}
              </div>
            </div>

            <div class="border row q-mb-sm">
              <div class="border-right q-pl-sm text-bold" style="width: 50%">
                UNIDADE:
                <span class="text">{{
                  $store.state.org.unidadeData?.nome || "N/A"
                }}</span>
              </div>
              <div class="q-pl-sm text-bold" style="width: 50%">
                Nº DE PESSOAS: <span class="text">{{ contarPessoas() }}</span>
              </div>
            </div>

            <div style="width: 100%" class="row">
              <div style="width: 50%" class="row">
                <div style="width: 33.3%" class="column">
                  <span
                    class="border-top border-bottom border-left q-pl-sm row justify-center text-bold"
                    >Status</span
                  >
                  <span class="border-left q-pl-sm row justify-center text-bold"
                    >Emissão</span
                  >
                  <span
                    class="border-left-rigth q-pl-sm row justify-center text-bold"
                    >Prev. Início</span
                  >
                  <span
                    class="border-left-rigth q-pl-sm row justify-center text-bold"
                    >Prev. Término</span
                  >
                  <span v-if="pt.logStatus"
                    ><span
                      v-for="(status, index) in pt.logStatus"
                      :key="index"
                      class="border-left-rigth q-pl-sm row justify-center text-bold"
                      >{{ formatarStatus(status.status) }}</span
                    >
                  </span>
                </div>
                <div style="width: 33.3%" class="column">
                  <span
                    class="border-top border-bottom border-left q-pl-sm row justify-center text-bold"
                    >Data</span
                  >
                  <span v-if="pt.dataHoraEmissao" class="border-left q-pl-sm">{{
                    formatarData(pt.dataHoraEmissao)
                  }}</span>
                  <span
                    v-if="pt.dataHoraInicio"
                    class="border-left-rigth q-pl-sm"
                    >{{ formatarData(pt.dataHoraInicio) }}</span
                  >
                  <span v-else class="border-left-rigth q-pl-sm">Sem Data</span>
                  <span
                    v-if="pt.dataHoraTermino"
                    class="border-left-rigth q-pl-sm"
                    >{{ formatarData(pt.dataHoraTermino) }}</span
                  >
                  <span v-else class="border-left-rigth q-pl-sm">Sem Data</span>
                  <span v-if="pt.logStatus"
                    ><span
                      v-for="(status, index) in pt.logStatus"
                      :key="index"
                      class="border-left-rigth q-pl-sm row"
                      >{{ formatarData(status.dataHora) }}</span
                    >
                  </span>
                </div>
                <div style="width: 33.4%" class="column">
                  <span
                    class="border-left-rigth border-top q-pl-sm row justify-center text-bold"
                    >Hora</span
                  >
                  <span
                    v-if="pt.dataHoraEmissao"
                    class="border-left-rigth q-pl-sm"
                    >{{ formatarHora(pt.dataHoraEmissao) }}</span
                  >
                  <span
                    v-if="pt.dataHoraInicio"
                    class="border-left-rigth q-pl-sm"
                    >{{ formatarHora(pt.dataHoraInicio) }}</span
                  >
                  <span
                    v-if="pt.dataHoraTermino"
                    class="border-left-rigth q-pl-sm"
                    >{{ formatarHora(pt.dataHoraTermino) }}</span
                  >
                  <span v-else class="border-left-rigth q-pl-sm">Sem Data</span>
                  <span v-if="pt.logStatus"
                    ><span
                      v-for="(status, index) in pt.logStatus"
                      :key="index"
                      class="border-left-rigth q-pl-sm row"
                      >{{ formatarHora(status.dataHora) }}</span
                    >
                  </span>
                </div>
              </div>
              <div
                style="width: 50%"
                class="border-left border-top border-right q-pl-sm q-pt-md q-pb-md text-bold"
              >
                Descrição do Trabalho:
                <span class="text">{{ pt.descricao }}</span>
              </div>
            </div>

            <div style="width: 100%" class="row">
              <span
                style="width: 50%"
                class="border-left-rigth border-bottom q-pl-sm text-bold"
                >Local: <span class="text">{{ pt.local }}</span></span
              >
              <span
                style="width: 50%"
                class="border-left-rigth border-bottom border-right q-pl-sm text-bold"
                >Emissor:
                <span class="text">{{ formatarEmissor() }}</span></span
              >
            </div>
          </section>
        </div>

        <div
          class="col-6 container-principal q-pt-md"
          v-for="(anexo, index) in anexos"
          :key="index"
        >
          <div class="border row anexo-card">
            <span class="row col-12 justify-center bg-deep-purple-1 anexo-info"
              ><strong style="margin-right: 5px">Nome:</strong> {{ anexo.nome }}
            </span>
            <span class="row col-12 justify-center bg-deep-purple-1 anexo-info"
              ><strong style="margin-right: 5px">Data:</strong>
              {{ formatarDataHoraEnvio(anexo.dataHoraEnvio) }}
            </span>
            <span class="row col-12 justify-center bg-deep-purple-1 anexo-info"
              ><strong style="margin-right: 5px">Responsável Upload:</strong>
              {{ anexo.usuarioNome }} ({{ anexo.usuarioMatricula || "N/A" }})
            </span>
            <span
              class="row col-12 justify-center bg-deep-purple-1 anexo-info"
              style="border-bottom: 1px solid black"
              ><strong style="margin-right: 5px">Status de Envio:</strong>
              {{ formatarStatusAnexo(anexo.statusPt) }}
            </span>
            <span
              class="row col-12 q-mt-md justify-center anexo-image-container"
            >
              <p
                v-if="
                  anexo.nome.split('.').pop() != 'pdf' &&
                  anexo.nome.split('.').pop() != 'xlsx'
                "
              >
                <img
                  class="anexo-img"
                  crossorigin="*"
                  :src="anexo.url"
                  alt=""
                  @error="onImageError"
                />
              </p>
              <p v-if="anexo.nome.split('.').pop() == 'xlsx'">
                <img
                  src="../../../../assets/excelLogo.png"
                  alt=""
                  class="anexo-img"
                />
              </p>
              <p v-if="anexo.nome.split('.').pop() == 'pdf'">
                <img
                  src="../../../../assets/pdfImage.png"
                  alt=""
                  class="anexo-img"
                />
              </p>
            </span>
          </div>
          <div v-if="anexo.quebra" class="teste"></div>
        </div>

        <div
          v-if="pt.observacoes || pt.obsAvaliacaoRisco"
          style="width: 100%"
          class="row q-mt-md"
        >
          <section style="width: 100%" class="column">
            <div
              class="border-left border-right border-top row justify-center bg-deep-purple-1"
            >
              <p
                class="row justify-center q-pl-sm text-bold"
                style="font-size: 14px"
              >
                Histórico de Observações
              </p>
            </div>
            <div class="row">
              <span
                class="q-pl-sm bg-grey-5 border-left text-bold justify-center row items-center border-top border-bottom"
                style="width: 80%; font-size: 13px"
                >Observação</span
              >
              <span
                class="row justify-center items-center border-top border-left border-bottom"
                style="width: 10%; font-size: 13px"
                ><strong>Nome Responsável</strong></span
              >
              <span
                class="border-top row justify-center items-center border"
                style="width: 10%; font-size: 13px"
                ><strong>Data</strong></span
              >
            </div>
            <div
              v-if="pt.obsAvaliacaoRisco"
              class="row historico-observacoes-row"
            >
              <span
                class="q-pl-sm border-left border-bottom border"
                style="width: 80%"
              >
                <span class="row col-12 q-pt-md">
                  <strong class="q-mr-xs">Status - Em Aberto: </strong>
                  {{ pt.obsAvaliacaoRisco }}
                </span></span
              >
              <span
                class="border-left border-bottom row justify-center items-center border"
                style="width: 10%"
                ><span style="font-size: 12px">
                  <strong>{{ pt.emissorNome }}</strong>
                </span></span
              >
              <span
                class="border-left border-right border-bottom row justify-center items-center border"
                style="width: 10%"
                ><span style="font-size: 12px; text-align: center">
                  {{
                    pt.logStatus && pt.logStatus[0]
                      ? formatarData(pt.logStatus[0].dataHora) +
                        " " +
                        formatarHora(pt.logStatus[0].dataHora)
                      : ""
                  }}
                </span></span
              >
            </div>
            <span v-if="pt.observacoes">
              <div
                v-for="(observacao, index) in pt.observacoes"
                :key="index"
                class="row historico-observacoes-row"
              >
                <span
                  class="q-pl-sm border-left border-bottom border"
                  style="width: 80%"
                >
                  <span class="row col-12 q-py-md">
                    <strong class="q-mr-xs"
                      >Status -
                      {{
                        formatarStatusObservacao(observacao.ptStatus)
                      }}:</strong
                    >
                    {{ observacao.observacao }}
                  </span></span
                >
                <span
                  class="row justify-center items-center border"
                  style="width: 10%"
                  ><span style="font-size: 12px">
                    <strong>{{ pt.emissorNome }}</strong>
                  </span></span
                >
                <span
                  class="border-left border-right border-bottom items-center row justify-center"
                  style="width: 10%"
                  ><span style="font-size: 12px"
                    ><p>{{ formatarData(observacao.dataHora) }}</p>
                    <span style="margin-left: 8px">{{
                      formatarHora(observacao.dataHora)
                    }}</span>
                    <strong></strong> </span
                ></span>
              </div>
            </span>
          </section>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="row align-center justify-center" id="base-mobile">
        <div class="row col-12 align-center">
          <div
            style="width: 15%"
            class="column justify-center items-center q-pa-sm"
          >
            <q-img
              v-if="logoVendor"
              :src="logoVendor"
              crossorigin="*"
              style="max-width: 80px; max-height: 60px"
              fit="contain"
              @error="onLogoError"
            />
            <q-img
              v-else
              crossorigin="*"
              src="../../../../assets/MULTPEX_VETOR.png"
              style="max-width: 80px; max-height: 60px"
              fit="contain"
            />
          </div>

          <section class="column q-pl-md" style="width: 85%">
            <div class="row q-mb-sm">
              <div
                class="border q-pl-sm text-bold row justify-center items-center"
                style="width: 70%"
              >
                ANEXOS DA PERMISSÃO PARA TRABALHO
              </div>
              <div class="border q-pl-sm text-bold" style="width: 30%">
                Nº:
                {{ pt.ptId ? pt.ptId.toString().padStart(7, "0") : "0000000" }}
              </div>
            </div>

            <div class="row q-mb-sm">
              <div class="border q-pl-sm text-bold" style="width: 60%">
                UNIDADE:
                <span class="text">{{
                  $store.state.org.unidadeData?.nome || "N/A"
                }}</span>
              </div>
              <div class="border q-pl-sm text-bold" style="width: 40%">
                ANEXOS: <span class="text">{{ numeroAnexos }}</span>
              </div>
            </div>

            <div style="width: 100%" class="row">
              <div style="width: 50%" class="row">
                <div style="width: 33.3%" class="column">
                  <span class="border-right">⠀⠀⠀⠀⠀⠀⠀⠀⠀</span>
                  <span
                    class="border-left-rigth border-top q-pl-sm row justify-center text-bold"
                    >Emissão</span
                  >
                  <span
                    class="border-left-rigth q-pl-sm row justify-center text-bold"
                    >Prev. Início</span
                  >
                  <span
                    class="border-left-rigth q-pl-sm row justify-center text-bold"
                    >Prev. Término</span
                  >
                  <span v-if="pt.logStatus"
                    ><span
                      v-for="(status, index) in pt.logStatus"
                      :key="index"
                      class="border-left-rigth q-pl-sm row justify-center text-bold"
                      >{{ formatarStatus(status.status) }}</span
                    >
                  </span>
                </div>
                <div style="width: 33.3%" class="column">
                  <span
                    class="border-left-rigth border-top q-pl-sm row justify-center text-bold"
                    >Data</span
                  >
                  <span
                    v-if="pt.dataHoraEmissao"
                    class="border-left-rigth q-pl-sm"
                    >{{ formatarData(pt.dataHoraEmissao) }}</span
                  >
                  <span
                    v-if="pt.dataHoraInicio"
                    class="border-left-rigth q-pl-sm"
                    >{{ formatarData(pt.dataHoraInicio) }}</span
                  >
                  <span v-else class="border-left-rigth q-pl-sm">Sem Data</span>
                  <span
                    v-if="pt.dataHoraTermino"
                    class="border-left-rigth q-pl-sm"
                    >{{ formatarData(pt.dataHoraTermino) }}</span
                  >
                  <span v-else class="border-left-rigth q-pl-sm">Sem Data</span>
                  <span v-if="pt.logStatus"
                    ><span
                      v-for="(status, index) in pt.logStatus"
                      :key="index"
                      class="border-left-rigth q-pl-sm row"
                      >{{ formatarData(status.dataHora) }}</span
                    >
                  </span>
                </div>
                <div style="width: 33.4%" class="column">
                  <span
                    class="border-left-rigth border-top q-pl-sm row justify-center text-bold"
                    >Hora</span
                  >
                  <span
                    v-if="pt.dataHoraEmissao"
                    class="border-left-rigth q-pl-sm"
                    >{{ formatarHora(pt.dataHoraEmissao) }}</span
                  >
                  <span
                    v-if="pt.dataHoraInicio"
                    class="border-left-rigth q-pl-sm"
                    >{{ formatarHora(pt.dataHoraInicio) }}</span
                  >
                  <span
                    v-if="pt.dataHoraTermino"
                    class="border-left-rigth q-pl-sm"
                    >{{ formatarHora(pt.dataHoraTermino) }}</span
                  >
                  <span v-else class="border-left-rigth q-pl-sm">Sem Data</span>
                  <span v-if="pt.logStatus"
                    ><span
                      v-for="(status, index) in pt.logStatus"
                      :key="index"
                      class="border-left-rigth q-pl-sm row"
                      >{{ formatarHora(status.dataHora) }}</span
                    >
                  </span>
                </div>
              </div>
              <div
                style="width: 50%"
                class="border-left-rigth border-top q-pl-sm q-pt-md q-pb-md text-bold"
              >
                Descrição do Trabalho:
                <span class="text">{{ pt.descricao }}</span>
              </div>
            </div>

            <div style="width: 100%" class="row bottom">
              <span
                style="width: 50%"
                class="border-left-rigth q-pl-sm text-bold"
                >Local: <span class="text">{{ pt.local }}</span></span
              >
              <span
                style="width: 50%"
                class="border-left-rigth q-pl-sm text-bold"
                >Emissor:
                <span class="text">{{ formatarEmissor() }}</span></span
              >
            </div>
          </section>
        </div>

        <div
          class="col-6 container-principal q-pt-md"
          v-for="(anexo, index) in anexos"
          :key="index"
        >
          <div class="border row anexo-card">
            <span class="row col-12 justify-center bg-deep-purple-1 anexo-info"
              ><strong style="margin-right: 5px">Nome:</strong> {{ anexo.nome }}
            </span>
            <span class="row col-12 justify-center bg-deep-purple-1 anexo-info"
              ><strong style="margin-right: 5px">Data:</strong>
              {{ formatarDataHoraEnvio(anexo.dataHoraEnvio) }}
            </span>
            <span class="row col-12 justify-center bg-deep-purple-1 anexo-info"
              ><strong style="margin-right: 5px">Responsável Upload:</strong>
              {{ anexo.usuarioNome }} ({{ anexo.usuarioMatricula || "N/A" }})
            </span>
            <span
              class="row col-12 justify-center bg-deep-purple-1 anexo-info"
              style="border-bottom: 1px solid black"
              ><strong style="margin-right: 5px">Status de Envio:</strong>
              {{ formatarStatusAnexo(anexo.statusPt) }}
            </span>
            <span
              class="row col-12 q-mt-md justify-center anexo-image-container"
            >
              <p
                v-if="
                  anexo.nome.split('.').pop() != 'pdf' &&
                  anexo.nome.split('.').pop() != 'xlsx'
                "
              >
                <img
                  class="anexo-img"
                  crossorigin="*"
                  :src="anexo.url"
                  alt=""
                  @error="onImageError"
                />
              </p>
              <p v-if="anexo.nome.split('.').pop() == 'xlsx'">
                <img
                  src="../../../../assets/excelLogo.png"
                  alt=""
                  class="anexo-img"
                />
              </p>
              <p v-if="anexo.nome.split('.').pop() == 'pdf'">
                <img
                  src="../../../../assets/pdfImage.png"
                  alt=""
                  class="anexo-img"
                />
              </p>
            </span>
          </div>
          <div v-if="anexo.quebra" class="teste"></div>
        </div>

        <div
          v-if="pt.observacoes || pt.obsAvaliacaoRisco"
          style="width: 100%"
          class="row q-mt-md"
        >
          <section style="width: 100%" class="column">
            <div class="border row justify-center bg-deep-purple-1">
              <p
                class="row justify-center q-pl-sm text-bold"
                style="font-size: 12px"
              >
                Histórico de Observações
              </p>
            </div>
            <div v-if="pt.obsAvaliacaoRisco" class="row border">
              <div class="col-12 q-pl-sm q-py-sm border-bottom">
                <div class="text-bold">Status - Em Aberto:</div>
                <div>{{ pt.obsAvaliacaoRisco }}</div>
                <div class="text-caption">Por: {{ pt.emissorNome }}</div>
              </div>
            </div>
            <div v-if="pt.observacoes">
              <div
                v-for="(observacao, index) in pt.observacoes"
                :key="index"
                class="row border"
              >
                <div class="col-12 q-pl-sm q-py-sm border-bottom">
                  <div class="text-bold">
                    Status -
                    {{ formatarStatusObservacao(observacao.ptStatus) }}:
                  </div>
                  <div>{{ observacao.observacao }}</div>
                  <div class="text-caption">
                    Por: {{ pt.emissorNome }} -
                    {{ formatarData(observacao.dataHora) }}
                    {{ formatarHora(observacao.dataHora) }}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { ref, onMounted } from "vue";
import { useQuasar } from "quasar";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

export default {
  props: {
    anexos: {
      required: true,
      type: Array,
    },
    numeroAnexos: {
      required: true,
      type: Number,
    },
  },
  setup(props) {
    const store = useStore();
    const route = useRoute();
    const quasar = useQuasar();

    const ptId = route.params.ptId;
    const pt = ref(false);
    let mobile = ref(false);
    const logoVendor = ref(null);

    if (quasar.platform.is.mobile) {
      mobile = ref(true);
    }

    const obterLogoVendor = () => {
      try {
        if (store.state.org?.unidadeData?.logo) {
          logoVendor.value = store.state.org.unidadeData.logo;
          return;
        }

        if (store.state.autenticacao?.logo?.logoImpressao) {
          logoVendor.value = store.state.autenticacao.logo.logoImpressao;
          return;
        }

        if (store.state.autenticacao?.logo?.logo) {
          logoVendor.value = store.state.autenticacao.logo.logo;
          return;
        }

        if (store.state.cliente?.logo) {
          logoVendor.value = store.state.cliente.logo;
          return;
        }

        logoVendor.value = null;
      } catch (error) {
        console.error("Erro ao obter logo do vendor:", error);
        logoVendor.value = null;
      }
    };

    const buscarDetalhePt = async () => {
      store.dispatch("pdt/hiddenHeader", false);

      const resposta = await store.dispatch("pdt/buscarDetalhePt", { ptId });
      pt.value = resposta.data.resultado.dados;

      obterLogoVendor();

      if (mobile.value) {
        zoomOut();
      }
      salvarPdf();
    };

    const formatarStatus = (status) => {
      const statusMap = {
        aberto: "Em Aberto",
        aguardando_assinaturas: "Em Ass.",
        iniciado: "Iniciado",
        encerrado: "Encerrado",
        finalizado: "Finalizado",
        cancelado: "Cancelado",
      };
      return statusMap[status] || status;
    };

    const formatarStatusAnexo = (status) => {
      return formatarStatus(status);
    };

    const formatarStatusObservacao = (status) => {
      const statusMap = {
        aguardando_assinaturas: "Em Ass.",
        iniciado: "Iniciado",
        encerrado: "Encerrado",
        cancelado: "Cancelado",
      };
      return statusMap[status] || status;
    };

    const formatarData = (dataHora) => {
      if (!dataHora) return "Sem Data";
      return dataHora.split(" ")[0].split("-").reverse().join("/");
    };

    const formatarHora = (dataHora) => {
      if (!dataHora) return "Sem Hora";
      return dataHora.split(" ")[1];
    };

    const formatarDataHoraEnvio = (dataHoraEnvio) => {
      if (!dataHoraEnvio) return "Data não disponível";
      const data = formatarData(dataHoraEnvio);
      const hora = formatarHora(dataHoraEnvio);
      return `${data} ${hora}`;
    };

    const formatarEmissor = () => {
      if (!pt.value) return "N/A";
      return `${pt.value.emissorNome || "N/A"} (${
        pt.value.emissorMatricula || "N/A"
      })`;
    };

    const onLogoError = () => {
      console.warn("Erro ao carregar logo do vendor, usando logo padrão");
      logoVendor.value = null;
    };

    const onImageError = (event) => {
      event.target.style.display = "none";
      const placeholder = document.createElement("div");
      placeholder.style.cssText =
        "width: 200px; height: 200px; background-color: #f5f5f5; display: flex; align-items: center; justify-content: center; border: 1px solid #ddd;";
      placeholder.innerHTML =
        '<span style="color: #999;">Imagem não disponível</span>';
      event.target.parentNode.appendChild(placeholder);
    };

    const contarPessoas = () => {
      if (!pt.value) return 0;
      const executantes = pt.value.executantes
        ? pt.value.executantes.length
        : 0;
      const responsaveis = pt.value.responsaveis
        ? pt.value.responsaveis.length
        : 0;
      return executantes + responsaveis;
    };

    const zoomOut = () => {
      const content = document.getElementById("base-mobile");
      if (content) {
        content.style.transform = "scale(0.9)";
        content.style.width = `300%`;
        content.style.height = `100%`;
        content.style.overflow = "visible";
        const windowHeight = window.innerHeight;
        const windowWidth = window.innerWidth;
        const centerX = (windowWidth - content.clientWidth) / 2;
        const centerY = (windowHeight - content.clientHeight) / 2;

        content.style.transformOrigin = "top left";
        content.style.left = centerX + "px";
        content.style.top = centerY + "px";
      }
    };

    const salvarPdf = async () => {
      quasar.notify({
        message: "Aguarde enquanto o PDF é gerado.",
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });

      if (props.anexos.length > 0) {
        props.anexos.forEach((value) => {
          if (value.url != null) {
            const imagem = new Image();
            imagem.crossOrigin = "anonymous";
            imagem.src = value.url;
            imagem.onload = function () {};
            imagem.onerror = function () {
              console.error("Erro ao pré-carregar a imagem");
            };
          }
        });
      }

      setTimeout(() => {
        let data = document.getElementById(
          mobile.value ? "base-mobile" : "base-desktop"
        );
        var hoje = new Date();
        let dataGerado = `${hoje.getDate().toString().padStart(2, "0")}/${(
          hoje.getMonth() + 1
        )
          .toString()
          .padStart(2, "0")}/${hoje.getFullYear()} ${hoje
          .getHours()
          .toString()
          .padStart(2, "0")}:${hoje.getMinutes().toString().padStart(2, "0")}`;

        html2canvas(data, {
          useCORS: true,
          allowTaint: true,
          scale: 2,
          logging: false,
        })
          .then((canvas) => {
            var imgWidth = 210;
            var pageHeight = 295;
            var imgHeight = (canvas.height * imgWidth) / canvas.width;

            var heightLeft = imgHeight;
            const imgData = canvas.toDataURL("image/jpeg", 0.95);

            var doc = new jsPDF("p", "mm", "a4", true);
            var position = 2;
            doc.addImage(imgData, "JPEG", 1, position, imgWidth - 2, imgHeight);
            heightLeft -= pageHeight;

            while (heightLeft >= 0) {
              position = heightLeft - imgHeight;
              doc.addPage();
              doc.addImage(
                imgData,
                "JPEG",
                1,
                position,
                imgWidth - 2,
                imgHeight
              );
              heightLeft -= pageHeight;
            }
            doc.save(`impressao_anexos_pt_${pt.value.ptId}_${dataGerado}.pdf`);
          })
          .catch((error) => {
            console.error("Erro ao gerar PDF:", error);
            quasar.notify({
              message: "Erro ao gerar PDF. Tente novamente.",
              color: "negative",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          });
      }, 3000);
    };

    onMounted(() => {
      obterLogoVendor();
      buscarDetalhePt();
    });

    return {
      ptId,
      pt,
      mobile,
      logoVendor,
      formatarStatus,
      formatarStatusAnexo,
      formatarStatusObservacao,
      formatarData,
      formatarHora,
      formatarDataHoraEnvio,
      formatarEmissor,
      onLogoError,
      onImageError,
      contarPessoas,
    };
  },
};
</script>

<style scoped>
.container-principal {
  margin-bottom: 20px;
}

.border {
  border: 1px solid black;
}

.border-left-rigth {
  border-left: 1px solid black;
  border-top: 1px solid black;
}

.border-left {
  border-left: 1px solid black;
}

.border-bottom {
  border-bottom: 1px solid black;
}

.border-right {
  border-right: 1px solid black;
}

.border-top {
  border-top: 1px solid black;
}

.flex {
  display: flex;
  justify-content: center;
}

.top p {
  margin: 0;
  font-size: 7px;
}

p {
  font-size: 12px;
}

.text {
  font-weight: normal;
}

.anexo-img {
  max-width: 150px;
  max-height: 150px;
  width: auto;
  height: auto;
  object-fit: contain;
}

.anexo-image-container {
  min-height: 160px;
  max-height: 160px;
  overflow: hidden;
}

.anexo-card {
  min-height: 280px;
  max-height: 280px;
}

.anexo-info {
  font-size: 11px;
  padding: 2px 4px;
  min-height: 25px;
  max-height: 25px;
}

.secao-anti-quebra {
  margin-bottom: 10px;
  page-break-inside: avoid;
}

@media print {
  @page {
    margin: 0.5cm !important;
    size: A4;
  }

  body {
    margin: 0;
    padding: 0;
  }

  p,
  span {
    font-size: 10px !important;
  }

  .text-bold {
    font-size: 10px !important;
  }

  .border-left,
  .border-left-rigth,
  .border {
    font-size: 9px !important;
  }

  .anexo-img {
    max-width: 100px !important;
    max-height: 100px !important;
    width: auto !important;
    height: auto !important;
    object-fit: contain !important;
  }

  .anexo-image-container {
    min-height: 110px !important;
    max-height: 110px !important;
    overflow: hidden !important;
  }

  .anexo-card {
    min-height: 200px !important;
    max-height: 200px !important;
  }

  .anexo-info {
    font-size: 9px !important;
    padding: 1px 2px !important;
    min-height: 18px !important;
    max-height: 18px !important;
  }

  .assinatura-responsaveis-wrap {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    display: flex !important;
    flex-wrap: wrap !important;
    justify-content: center !important;
    align-items: flex-start !important;
    gap: 8px !important;
  }

  .assinatura-responsavel-card {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    max-width: 32% !important;
    min-width: 220px !important;
    margin-bottom: 8px !important;
  }

  .secao-anti-quebra {
    margin-bottom: 10px;
    page-break-inside: avoid;
  }

  .pagina-margem {
    margin: 0.5cm !important;
    box-sizing: border-box;
    width: auto !important;
    height: auto !important;
  }

  .historico-observacoes-section {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    border-collapse: collapse !important;
  }

  .historico-observacoes-header,
  .historico-observacoes-table-header {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    page-break-after: avoid !important;
    break-after: avoid !important;
    border-collapse: collapse !important;
  }

  .historico-observacoes-row {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    border-collapse: collapse !important;
    orphans: 2;
    widows: 2;
    margin: 0 !important;
    padding: 0 !important;
  }
}

.pagina-margem {
  margin: 24px;
}
</style>
